import { service } from '../../../helpers/http'

const MODULE = 'dynamicCalendar'

// ---- Calendários acadêmicos ----
export const ActionGetAcademicCalendars = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'indexAcademicCalendars', payload })

export const ActionGetAcademicCalendar = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'showAcademicCalendar', payload })

export const ActionPostAcademicCalendar = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'storeAcademicCalendar', payload })

export const ActionPutAcademicCalendar = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'updateAcademicCalendar', payload })

export const ActionDeleteAcademicCalendar = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'deleteAcademicCalendar', payload })

// ---- Cenários ----
export const ActionGetCalendarScenarios = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'indexCalendarScenarios', payload })

export const ActionGetCalendarScenario = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'showCalendarScenario', payload })

export const ActionPostCalendarScenario = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'storeCalendarScenario', payload })

export const ActionPutCalendarScenario = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'updateCalendarScenario', payload })

export const ActionDeleteCalendarScenario = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'deleteCalendarScenario', payload })

export const ActionGetScenarioMetrics = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'scenarioMetrics', payload })

export const ActionGetCoverage = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'calendarCoverage', payload })

// ---- Eventos do calendário ----
export const ActionGetCalendarEvents = ({ dispatch }, { calendarId, start, end }) =>
    service({ module: MODULE, action: 'indexCalendarEvents', params: { calendar: calendarId, start, end } })

export const ActionPostCalendarEvent = ({ dispatch }, { calendarId, data }) =>
    service({ module: MODULE, action: 'storeCalendarEvent', params: { calendar: calendarId }, payload: data })

export const ActionPutCalendarEvent = ({ dispatch }, { calendarId, eventId, data }) =>
    service({ module: MODULE, action: 'updateCalendarEvent', params: { calendar: calendarId, event: eventId }, payload: data })

export const ActionDeleteCalendarEvent = ({ dispatch }, { calendarId, eventId }) =>
    service({ module: MODULE, action: 'deleteCalendarEvent', params: { calendar: calendarId, event: eventId } })

// ---- Acesso / permissões ----
export const ActionGetCalendarAccess = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'calendarAccess', payload })

export const ActionGetCalendarRoles = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'calendarRoles', params: payload || {} })

export const ActionAttachCalendarRole = ({ dispatch }, { id }) =>
    service({ module: MODULE, action: 'attachCalendarRole', params: { id } })

export const ActionDetachCalendarRole = ({ dispatch }, { id }) =>
    service({ module: MODULE, action: 'detachCalendarRole', params: { id } })

export const ActionGetCalendarSettings = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'calendarSettings', params: { calendar_id: (payload && payload.calendarId) || undefined } })

export const ActionSaveCalendarSettings = ({ dispatch }, { config, calendarId }) =>
    service({ module: MODULE, action: 'saveCalendarSettings', payload: { config, calendar_id: calendarId || null } })

export const ActionGetManagerSummary = ({ dispatch }, { calendarId }) =>
    service({ module: MODULE, action: 'managerSummary', params: { calendar_id: calendarId } })

export const ActionGetCalendarIndicators = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'calendarIndicators', payload })

export const ActionEnqueueScheduling = ({ dispatch }, { academicCalendarId, scenarioId }) =>
    service({ module: MODULE, action: 'enqueueScheduling', payload: { academic_calendar_id: academicCalendarId, scenario_id: scenarioId || null } })

export const ActionGetSchedulingSuggestions = ({ dispatch }, { runId }) =>
    service({ module: MODULE, action: 'schedulingSuggestions', params: { runId } })

export const ActionGetAlgorithmRun = ({ dispatch }, { runId }) =>
    service({ module: MODULE, action: 'algorithmRun', params: { runId } })

export const ActionEnqueueCoverageOpt = ({ dispatch }, { academicCalendarId, scenarioId, targetDays, priority, scope, scopeRef }) =>
    service({ module: MODULE, action: 'enqueueCoverageOpt', payload: { academic_calendar_id: academicCalendarId, scenario_id: scenarioId || null, target_days: targetDays || null, priority: priority || 'saturdays', scope: scope || 'national', scope_ref_id: scopeRef || null } })

export const ActionGetCoverageOptSuggestions = ({ dispatch }, { runId }) =>
    service({ module: MODULE, action: 'coverageOptSuggestions', params: { runId } })

export const ActionApplyCoverageOpt = ({ dispatch }, { scenarioId, scope, scopeRef, addSaturdays, removeBridges }) =>
    service({ module: MODULE, action: 'applyCoverageOpt', params: { scenarioId }, payload: { scope: scope || 'national', scope_ref_id: scopeRef || null, add_saturdays: addSaturdays || [], remove_bridges: removeBridges || [] } })

export const ActionGetScopedDays = ({ dispatch }, { scenarioId, scope, refId }) =>
    service({ module: MODULE, action: 'getScopedDays', params: { scenarioId, scope: scope || 'national', ref_id: refId || undefined } })

// Só inclui no payload as listas realmente informadas — o backend guarda cada
// lista com $request->has(), então omitir uma chave preserva o que já existe
// (ex.: EditDiasModal manda só saturdays+bridges e não apaga feriados).
export const ActionSetScopedDays = ({ dispatch }, payload) => {
    const { scenarioId, scope, refId } = payload
    const body = { scope: scope || 'national', ref_id: refId || null }
    const fields = ['saturdays', 'bridges', 'holidays_excl', 'holidays_extra', 'saturdays_excl', 'bridges_excl', 'predecessors', 'saturdays_all']
    fields.forEach((k) => { if (payload[k] !== undefined) body[k] = payload[k] })
    return service({ module: MODULE, action: 'setScopedDays', params: { scenarioId }, payload: body })
}

export const ActionSyncRolePermissions = ({ dispatch }, { id, keys }) =>
    service({ module: MODULE, action: 'syncRolePermissions', params: { id }, payload: { keys } })

export const ActionSaveRoleScope = ({ dispatch }, { id, scope }) =>
    service({ module: MODULE, action: 'saveRoleScope', params: { id }, payload: { scope } })

export const ActionGetStates = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'states', params: payload || {} })

export const ActionGetRoleUsers = ({ dispatch }, { id, page, per_page, search }) =>
    service({ module: MODULE, action: 'roleUsers', params: { id, page, per_page, search: search || undefined } })

export const ActionSearchInstitutionUsers = ({ dispatch }, { search }) =>
    service({ module: MODULE, action: 'searchInstitutionUsers', params: { search } })

export const ActionAttachUserRole = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'attachUserRole', payload })

export const ActionRevokeUserRole = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'revokeUserRole', payload })

export const ActionCreateRole = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'createRole', payload })

// ---- Publicação e alterações (Etapa 4) ----
export const ActionPublishCalendar = ({ dispatch }, { id, published }) =>
    service({ module: MODULE, action: 'publishCalendar', payload: { id, published } })

export const ActionGetChangeRequests = ({ dispatch }, { calendarId }) =>
    service({ module: MODULE, action: 'indexChangeRequests', params: { calendar: calendarId } })

export const ActionPostChangeRequest = ({ dispatch }, { calendarId, data }) =>
    service({ module: MODULE, action: 'storeChangeRequest', params: { calendar: calendarId }, payload: data })

export const ActionRespondChangeRequest = ({ dispatch }, { id, decision, response }) =>
    service({ module: MODULE, action: 'respondChangeRequest', params: { id }, payload: { decision, response } })

export const ActionPublishChangeRequest = ({ dispatch }, { id, comment }) =>
    service({ module: MODULE, action: 'publishChangeRequest', params: { id }, payload: { comment: comment || null } })

export const ActionDeleteChangeRequest = ({ dispatch }, { id }) =>
    service({ module: MODULE, action: 'deleteChangeRequest', payload: { id } })

// ---- Aprovação ----
export const ActionGetApprovals = ({ dispatch }, { calendarId, scenarioId, scope, refId }) =>
    service({
        module: MODULE,
        action: 'indexApprovals',
        params: {
            calendar: calendarId,
            scenario_id: scenarioId || undefined,
            scope: scope || 'national',
            ref_id: refId || undefined,
        },
    })

export const ActionApproveBatch = ({ dispatch }, { calendarId, eventIds, decision, comment }) =>
    service({ module: MODULE, action: 'approveBatch', params: { calendar: calendarId }, payload: { event_ids: eventIds, decision, comment } })

export const ActionReopenApproval = ({ dispatch }, { calendarId, eventId, reason }) =>
    service({ module: MODULE, action: 'reopenApproval', params: { calendar: calendarId, event: eventId }, payload: { reason: reason || null } })

export const ActionApprovalAck = ({ dispatch }, { calendarId, scenarioId, decision, justification, scope, refId }) =>
    service({
        module: MODULE,
        action: 'approvalAck',
        params: { calendar: calendarId },
        payload: {
            scenario_id: scenarioId || null,
            decision,
            justification: justification || null,
            scope: scope || 'national',
            ref_id: refId || null,
        },
    })

export const ActionApproveStep = ({ dispatch }, { calendarId, eventId, data }) =>
    service({ module: MODULE, action: 'approveStep', params: { calendar: calendarId, event: eventId }, payload: data })

// ---- Considerações ----
export const ActionGetConsiderations = ({ dispatch }, { calendarId }) =>
    service({ module: MODULE, action: 'indexConsiderations', params: { calendar: calendarId } })

export const ActionPostConsideration = ({ dispatch }, { calendarId, data }) =>
    service({ module: MODULE, action: 'storeConsideration', params: { calendar: calendarId }, payload: data })

export const ActionPutConsideration = ({ dispatch }, { id, data }) =>
    service({ module: MODULE, action: 'updateConsideration', payload: { id, ...data } })

export const ActionDeleteConsideration = ({ dispatch }, { id }) =>
    service({ module: MODULE, action: 'deleteConsideration', payload: { id } })

// ---- Catálogos ----
export const ActionGetEventTypes = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'eventTypes', payload })

export const ActionGetEventCategories = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'eventCategories', payload })

export const ActionGetEventPublics = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'eventPublics', payload })

export const ActionGetEventAreas = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'eventAreas', payload })

export const ActionGetEventScopes = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'eventScopes', payload })

export const ActionGetBrands = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'brands', payload })

export const ActionGetCampuses = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'campuses', payload })

export const ActionGetCourses = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'courses', payload })

export const ActionGetCourseModalities = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'courseModalities', payload })

export const ActionGetGroups = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'groups', payload })

// ---- Reuso: eventos / feriados / períodos letivos ----
export const ActionGetEventCalendars = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'indexEventCalendars', payload })

export const ActionGetHolidays = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'indexHolidays', payload })

export const ActionGetWorkTimes = ({ dispatch }, payload) =>
    service({ module: MODULE, action: 'indexWorkTimes', payload })
